import _ from 'underscore';
import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import ButtonField from './buttonField';

/**
 * @class DropdownField
 */
export default class DropdownField extends ButtonField {
    type = 'align';
    supports = null;

    /**
     * Initializes the dropdwn field
     *
     * @param {jQuery} control `<div/>` container of field
     * @param {Object} translations
     */
    constructor(control, translations) {
        super(control, translations);

        this.tpl = _.template(this.getDropdownTemplateString());

        this.dropdown = $('.dropdown-menu', control);
        this.registerEventsForDropdown(this.dropdown);
    }

    getDropdownTemplateString() {
        return `
            <li<% if (active) { %> class="active"<% } %>>
                <a href="" data-item="<%= key %>">
                    <%= value %>
                </a>
            </li>
        `;
    }

    /**
     * Register click event on dropdown.
     */
    registerEventsForDropdown() {}

    /**
     * Set options for dropdown
     *
     * @param {Object} options
     */
    setOptions(options) {
        this.dropdown.html('');

        options.forEach((option) => {
            this.dropdown.append(this.tpl(option));
        });
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.updateOptions(item);
        this.updateText(item);
    }

    /**
     * Update text with item value.
     */
    updateText() {}

    /**
     * Update options with item value.
     */
    updateOptions() {}

    /**
     * Update item with field value.
     */
    updateItem() {}
}
